<template>
  <div id="app">
    <keep-alive :include="['NewBoostPage']">
      <router-view />
    </keep-alive>
    <app-tab-bar v-if="showTabBar" />
  </div>
</template>

<script>
import AppTabBar from "@/components/TabBarNew.vue";
export default {
  name: "App",
  components: {
    AppTabBar,
  },
  computed: {
    showTabBar() {
      const roleName = this.$store.state.roleName;
      if (roleName === "客户经理" || roleName === "客户主管") {
        return false;
      } else {
        // 只在需要显示TabBar的路由显示
        return ["/home", "/boostOrders", "/newBoost"].includes(
          this.$route.path
        );
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  max-width: 100vw;
  overflow-x: hidden;
}

body {
  margin: 0;
  padding: 0;
}
</style>
